import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-p2-client-update',
  templateUrl: './p2-client-update.component.html',
  styleUrls: ['./p2-client-update.component.css']
})
export class P2ClientUpdateComponent implements OnInit {
    public itemsListClientUpdates: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadClientUpdates() {
        this.itemsListClientUpdates = await this.datatask.Post(145);
    }

    private async init() {
        this.loadClientUpdates();
    }

    ngOnInit() {
        this.init();
    }
}
